// extracted by mini-css-extract-plugin
export default {"title":"MyParcels_title__6oIeN","button_new_parcel":"MyParcels_button_new_parcel__Rm8XO","parcel_table":"MyParcels_parcel_table__lHWHV"};